import { match } from 'ts-pattern'

import { isQuickbooksCreditNoteApplicationImport } from './quickbooksSyncErrorContent'
import { SyncErrorTaskInput } from './types'

const OPERATION_INDEX = 7

export const syncErrorOperation = (
  input: SyncErrorTaskInput
): string | undefined => {
  const segments = input.syncErrorKey.split('|')

  return segments.length > OPERATION_INDEX
    ? segments[OPERATION_INDEX] || undefined
    : undefined
}

export const syncErrorOperationLabel = (
  input: SyncErrorTaskInput
): string | undefined =>
  isQuickbooksCreditNoteApplicationImport(input)
    ? 'credit note application import'
    : match(syncErrorOperation(input))
        .with('DEAL_STAGE', () => 'deal stage update')
        .with('DEAL_PROPERTIES', () => 'deal sync')
        .with('DEAL_LINE_ITEMS', () => 'deal line item sync')
        .with('SIGNED_PDF', () => 'signed PDF upload')
        .otherwise(() => undefined)
